module.exports = __webpack_public_path__ + "58f22465ee21ab6c292b7fd00003b189.svg";